"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeInstallations = exports.normalizeSubscriptions = exports.normalizeColumns = void 0;
const immer_1 = __importDefault(require("immer"));
const lodash_1 = __importDefault(require("lodash"));
const shared_1 = require("./github/shared");
const shared_2 = require("./shared");
function normalizeColumns(columns, updatedAt) {
    const items = columns || [];
    const byId = {};
    const allIds = items.map((column) => {
        const id = column.id || shared_2.guid();
        byId[id] = immer_1.default(column, draft => {
            draft.id = id;
            draft.subscriptionIds = column.subscriptionIds || [];
            draft.subscriptionIdsHistory = column.subscriptionIdsHistory || [];
            draft.createdAt = column.createdAt || new Date().toISOString();
            draft.updatedAt = column.updatedAt || new Date().toISOString();
            draft.subscriptionIds.forEach(subscriptionId => {
                if (!subscriptionId)
                    return;
                if (!draft.subscriptionIdsHistory.includes(subscriptionId)) {
                    draft.subscriptionIdsHistory.push(subscriptionId);
                }
            });
        });
        return id;
    });
    return { allIds, byId, updatedAt: updatedAt || new Date().toISOString() };
}
exports.normalizeColumns = normalizeColumns;
function normalizeSubscriptions(subscriptions, updatedAt) {
    const items = subscriptions || [];
    const byId = {};
    const allIds = items.map((subscription) => {
        const id = subscription.id || shared_1.getUniqueIdForSubscription(subscription);
        byId[id] = immer_1.default(subscription, draft => {
            draft.id = id;
            draft.data = subscription.data || {};
            draft.createdAt = subscription.createdAt || new Date().toISOString();
            draft.updatedAt = subscription.updatedAt || new Date().toISOString();
        });
        return id;
    });
    return { allIds, byId, updatedAt: updatedAt || new Date().toISOString() };
}
exports.normalizeSubscriptions = normalizeSubscriptions;
function normalizeInstallations(installations) {
    const items = lodash_1.default.orderBy((installations || []).filter(Boolean), [
        'account.login',
        'asc',
    ]);
    const allIds = [];
    const allOwnerNames = [];
    // const allRepoFullNames: string[] = []
    const byId = {};
    const byOwnerName = {};
    // const byRepoFullName: Record<string, number> = {}
    items.forEach(installation => {
        if (!(installation && installation.id))
            return;
        allIds.push(installation.id);
        byId[installation.id] = installation;
        const ownerName = shared_2.normalizeUsername((installation.account && installation.account.login) || undefined);
        if (ownerName) {
            allOwnerNames.push(ownerName);
            byOwnerName[ownerName] = installation.id;
        }
        /*
        const repos = installation.repositories
    
        if (repos) {
          repos.forEach(repo => {
            if (!(repo && repo.repoName)) return
    
            const _ownerName = normalizeUsername(repo.ownerName || undefined)
            if (_ownerName) {
              allOwnerNames.push(_ownerName)
              byOwnerName[_ownerName] = installation.id!
            }
    
            const repoName = `${repo.repoName}`.trim().toLowerCase()
            if (repoName) {
              const repoFullName = `${_ownerName}/${repoName}`
              allRepoFullNames.push(repoFullName)
              byRepoFullName[repoFullName] = installation.id!
            }
          })
        }
        */
    });
    return {
        allIds: lodash_1.default.uniq(allIds),
        allOwnerNames: lodash_1.default.uniq(allOwnerNames),
        // allRepoFullNames: _.uniq(allRepoFullNames),
        byId,
        byOwnerName,
    };
}
exports.normalizeInstallations = normalizeInstallations;
//# sourceMappingURL=state.js.map